import React, { useContext, useEffect } from "react";
import { Col, ListGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppContext } from "../context/appContext";
import { addNotifications, resetNotifications } from "../features/userSlice";
import "./Sidebar.css";
import { API_BASE_URL } from "../apiConfig";

function Sidebar() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const {
    socket,
    setMembers,
    members,
    setCurrentRoom,
    setRooms,
    privateMemberMsg,
    rooms,
    setPrivateMemberMsg,
    currentRoom,
  } = useContext(AppContext);

  function joinRoom(roomId, isPublic = true) {
    if (!user) {
      return alert("Please login");
    }
    // Leave previous room
    if (currentRoom) {
      socket.emit("leaveRoom", { roomId: currentRoom });
    }
    // Join new room
    socket.emit("joinRoom", { roomId, userId: user._id });
    setCurrentRoom(roomId);

    if (isPublic) {
      setPrivateMemberMsg(null);
    }
    // dispatch for notifications
    dispatch(resetNotifications(roomId));
  }

  useEffect(() => {
    // Listen for global notifications to increment unread count for other rooms
    socket.off("notifications").on("notifications", (roomId) => {
      if (currentRoom !== roomId) {
        dispatch(addNotifications(roomId));
      }
    });

    return () => {
      socket.off("notifications");
    };
  }, [currentRoom, dispatch, socket]);

  useEffect(() => {
    if (user) {
      getRooms();
      socket.emit("new-user");
      // Use existing currentRoom if set, otherwise default to room_global_general
      const defaultRoom = currentRoom && currentRoom.length > 0 ? currentRoom : "room_global_general";
      setCurrentRoom(defaultRoom);
      socket.emit("joinRoom", { roomId: defaultRoom, userId: user._id });

      // 5-minute periodic sync fallback
      const interval = setInterval(getRooms, 5 * 60 * 1000);

      // Listen for real-time room updates and deletions
      const handleRoomsUpdate = () => getRooms();
      socket.on("roomUpdated", handleRoomsUpdate);
      socket.on("roomDeleted", handleRoomsUpdate);

      return () => {
        clearInterval(interval);
        socket.off("roomUpdated", handleRoomsUpdate);
        socket.off("roomDeleted", handleRoomsUpdate);
      };
    }
  }, [user, socket]);

  socket.off("new-user").on("new-user", (payload) => {
    setMembers(payload);
  });

  function getRooms() {
    fetch(API_BASE_URL + "/api/chat/rooms?t=" + Date.now())
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // Sort global rooms first, then active event rooms
          const sorted = [...data.rooms].sort((a, b) => {
            if (a.type === "global" && b.type !== "global") return -1;
            if (a.type !== "global" && b.type === "global") return 1;
            return 0;
          });

          // Filter: only show global rooms OR rooms where current user is in participants
          const visible = sorted.filter((room) => {
            if (room.type === "global") return true;
            return room.participants?.some((p) => String(p) === String(user?._id));
          });

          setRooms(visible);
        }
      })
      .catch((err) => console.error("Error fetching rooms:", err));
  }

  if (!user) {
    return <></>;
  }

  return (
    <>
      <h2>Available Groups</h2>
      <ListGroup>
        {rooms.map((room, idx) => (
          <ListGroup.Item
            key={idx}
            onClick={() => joinRoom(room._id)}
            active={room._id === currentRoom}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {room.name}{" "}
            {currentRoom !== room._id && user.newMessages && user.newMessages[room._id] > 0 && (
              <span className="badge rounded-pill bg-primary">
                {user.newMessages[room._id]}
              </span>
            )}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </>
  );
}

export default Sidebar;
